import { render, staticRenderFns } from "./StudentMarks.vue?vue&type=template&id=28a87554"
import script from "./StudentMarks.vue?vue&type=script&lang=js"
export * from "./StudentMarks.vue?vue&type=script&lang=js"
import style0 from "./StudentMarks.vue?vue&type=style&index=0&id=28a87554&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports